// extracted by mini-css-extract-plugin
export default {"container":"RichText_container__-b2lO","iframe":"RichText_iframe__NHsZ5","wrapper":"RichText_wrapper__8CSnE","divider":"RichText_divider__+LvMa"};